import { AdvancedMarker, Pin } from "@vis.gl/react-google-maps";
import { HHNTheme } from "hhn-commons";
import React from "react";
import theme from "../../theme";

function LocationMarker(props: {
  address: any;
  onClick: () => void;
  text: string;
  isSelected?: boolean;
}) {
  return (
    <AdvancedMarker
      position={{
        lat: props.address.location.coordinates[1],
        lng: props.address.location.coordinates[0],
      }}
      title={props.address.name}
      onClick={props.onClick}
    >
      <Pin
        background={
          props.isSelected ? theme.palette.primary.main : HHNTheme.route.stop
        }
        borderColor={theme.palette.common.white}
        glyphColor={theme.palette.common.white}
      >
        {props.text}
      </Pin>
    </AdvancedMarker>
  );
}

export default LocationMarker;
